import { IconsTypesProps } from '../icons/types';

export const PumpWithoutPropeler = ({
  width = 64,
  height = 113,
  fill = '#f4f4f7',
}: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22207_144092)">
      <path
        d="M63.2121 102.095C63.2121 107.916 58.4777 112.612 52.6955 112.612H10.7842C4.9632 112.612 0.267578 107.878 0.267578 102.095C0.267578 96.3131 4.9632 91.5787 10.7842 91.5787H12.0648V77.259H10.7454C7.2916 77.259 4.49751 74.4649 4.49751 71.0111V70.0797C4.49751 66.6259 7.2916 63.8319 10.7454 63.8319H12.0648V18.5444C12.0648 16.41 13.8111 14.6637 15.9455 14.6637H47.4954C49.6298 14.6637 51.3761 16.41 51.3761 18.5444V63.8319H52.6955C56.1493 63.8319 58.9434 66.6259 58.9434 70.0797V71.0111C58.9434 74.4649 56.1493 77.259 52.6955 77.259H51.3761V91.5787H52.6567C58.4777 91.5787 63.2121 96.2743 63.2121 102.095Z"
        fill={fill}
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M20.6016 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M26.1514 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M31.7402 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M37.3281 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M42.877 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M45.1665 14.6248V5.38875C45.1665 2.82751 43.0709 0.770752 40.5485 0.770752H22.7362C20.1749 0.809559 18.1182 2.86631 18.1182 5.38875V14.6248H21.9988V5.38875C21.9988 4.96188 22.3481 4.65143 22.7362 4.65143H40.5097C40.7813 4.65143 41.053 4.80666 41.1694 5.0783V14.6636H45.1665V14.6248Z"
        fill="#C9CDCF"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_22207_144092">
        <rect width="64" height="113" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
